import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import DashboardLayoutCustom2 from "examples/LayoutContainers/DashboardLayoutCustom2";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import { getRequestReviewAysnc } from "features/actions/auth";
import { useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import deleteIcon from "assets/images/icons/deleteIcon.svg";
import Grid from "@mui/material/Grid";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import dayjs from "dayjs";
import { TextField } from "@mui/material";
import {
  Box,
  IconButton,
  Modal,
  Skeleton,
  TablePagination,
  Typography,
} from "@mui/material";

import MDInput from "components/MDInput";
import showIcon from "assets/images/icons/showicon.svg";
import sendIcon from "assets/images/icons/send.svg";
import avatarEditIcon from "assets/images/icons/update-b-icon.svg";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import Button from "@mui/material/Button";

import CloseIcon from "@mui/icons-material/Close";
import { QRCodeSVG } from "qrcode.react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { sendRequestReview } from "features/actions/auth";
import { deleteRequestReview } from "features/actions/auth";

import { cancelRequestReview } from "features/actions/auth";
import { ReviewCount } from "../review-count";
import toast from "react-hot-toast";
import { from } from "stylis";

import {
  editRequestAysnc,
  updateReviewRequestAsync,
} from "features/actions/auth";
import { getRequestReviewListAsync } from "features/actions/auth";
import { getReviewRequestByIdAsync } from "features/actions/auth";
import { deleteReviewRequestByIdAsync } from "features/actions/auth";
import { editReviewRequestByIdAsync } from "features/actions/auth";
import { sendReviewRequestAsync } from "features/actions/auth";
import link from "assets/theme/components/link";
function ReviewsList() {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 550,
    bgcolor: "background.paper",
    borderRadius: "12px",
    boxShadow: 24,
    p: { xs: 1, sm: 4 },
    textAlign: "center",
    py: 2,
  };

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email_address: "",
    phone_number: "",
    visit_date: "",
    note: "",
  });

  const handleDateChange = (newDate) => {
    setFormData((prev) => ({
      ...prev,
      visit_date: newDate ? dayjs(newDate).format("YYYY-MM-DD") : "",
    }));
  };

  const [formErrors, setFormErrors] = useState({});
  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    setFormErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    editRequestData,
    getprofile,
    requestReviewListData,
    reviewRequestByIDData,
  } = useSelector((state) => state.auth);
  const [showloader, setShowloader] = useState(false);
  const [pagination, setPagination] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [isLoading, setIsLoading] = useState(true);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [viewSendRequest, setViewSendRequest] = useState(false);
  const [permissionModal, setPermissionModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deletedId, setDeletedId] = useState(null);
  const [updateId, setUpdateId] = useState(null);
  const business_id = useSelector((state) => state.dashboard.commonId);
  const [open, setOpen] = React.useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [showRequestData, setShowRequestData] = useState([]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const totalCount = requestReviewListData?.total || 0;

  const handlePageChange = (event, newPage) => {
    setPagination(true);
    setPage(newPage);
  };
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPagination(true);
    setPage(0);
  };

  const username = getprofile?.userProfile?.username;
  const offset = page * rowsPerPage;
  useEffect(() => {
    if (username) {
      dispatch(
        getRequestReviewListAsync({ username, maxSize: rowsPerPage, offset })
      );
    }
  }, [page, rowsPerPage, username, dispatch]);

  const [showData, setShowData] = useState([]);

  const handleView = (id) => {
    const selectedData = requestReviewListData.data.find(
      (item) => item.id === id
    );
    setShowData(selectedData);
    setViewModalOpen(true);
  };
  const linkToCopy = `${window.location.host}/redirect?link=${showData.link}`;
  const [reviewRequestByID, setReviewRequestByID] = useState(
    reviewRequestByIDData
  );
  const handleSNewendRequest = (id) => {
    const requestReviewLink = `https://${window.location.host}/redirect?link=https://${window.location.host}/redirect/${id} `;
    const payload = {
      review_request_id: id,
      link: requestReviewLink,
    };
    dispatch(sendReviewRequestAsync({ payload }))
      .unwrap()
      .then(() => {
        dispatch(getRequestReviewListAsync({ username, maxSize: rowsPerPage, offset }))
        setReviewRequestByID((prev) => {
          if (!prev?.details) return prev;
          return {
            ...prev,
            details: prev.details.map((item) =>
              item.review_request_id === id
                ? { ...item, no_of_requests: (item.no_of_requests || 0) + 1 }
                : item
            ),
          };
        });
        setPagination((prev) => !prev);
      });

    setViewSendRequest(false);
  };

  const handleSendRequest = (rowData) => {
    const contact_id = rowData?.contactId;
    if (username) {
      dispatch(getReviewRequestByIdAsync({ username, contact_id }))
        .then(() => {
          setSelectedRequest(rowData);
          setViewSendRequest(true);
        })
        .catch((error) => {
          console.error("Error fetching request review list:", error);
        });
    }
  };
  const handleRemove = () => {
    dispatch(deleteReviewRequestByIdAsync({ username, deletedId })).then(() => {
      toast.success("Review request has been deleted");
      dispatch(
        getRequestReviewListAsync({ username, maxSize: rowsPerPage, offset })
      );
      setDeletedId(null);
      setPermissionModal(false);
    });
    setViewSendRequest(false);
  };

  const handleEditRequest = (id) => {
    const selected = requestReviewListData?.list?.find(
      (item) => item.id === id
    );
    setShowRequestData({ review_request: selected });
    setUpdateId(id);
    setEditModal(true);
  };
  const addReviewHandler = async () => {
    return navigate("/review-details");
  };

  const updateReviewRequest = () => {
    const formDataObject = {
      request_id: updateId,
      first_name: formData.first_name,
      last_name: formData.last_name,
      email: formData.email_address,
      phone_number: formData.phone_number,
      visit_date: formData.visit_date,
      note: formData.note,
    };
    dispatch(
      editReviewRequestByIdAsync({
        username,
        request_id: updateId,
        formDataObject,
      })
    )
      .then(() => {
        setEditModal(false);
        setUpdateId(null);
        toast.success("Request Review Updated Successfully");
        dispatch(
          getRequestReviewListAsync({ username, maxSize: rowsPerPage, offset })
        );
      })
      .catch((err) => {
        console.error("Update failed:", err);
        toast.error("Failed to update review request");
      });
  };

  return (
    <>
      <MDBox sx={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
        <DashboardLayoutCustom2>
          {/* {screenLoading && <Loader />} */}
          <DashboardNavbar />

          {/* <MDBox /> */}
          <ReviewCount key={refreshKey} />
          <MDBox
            sx={{
              margin: "0px 15px 0px 15px",
              boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
              backgroundColor: "#ffffff",
              borderRadius: { xs: "16px", sm: "20px" },
              p: { xs: "8px", sm: 2 },
              "@media(max-width:786px)": { mx: 2 },
            }}
          >
            <MDBox
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
                "@media(min-width:576px)": { flexDirection: "row" },
              }}
            >
              <MDTypography
                mt={2}
                mb={2}
                sx={{
                  color: "#292929",
                  fontFamily: "Urbanist",
                  fontSize: "24px",
                  fontWeight: 700,
                  lineHeight: "28.8px",
                }}
              >
                Request Review
              </MDTypography>
              {/* <MDBox
                sx={{
                  textAlign: "right",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: { xs: "10px", lg: "25px" },
                }}
              >
                <MDTypography
                  mt={{ xs: 0, sm: 2 }}
                  mb={{ xs: 0, sm: 2 }}
                  sx={{ color: "#344767" }}
                >
                  <MDButton
                    elevation={0}
                    sx={{
                      cursor: "pointer",
                      borderRadius: "45px",
                      backgroundColor: "#318BEC",
                      fontFamily: "urbanist",
                      textTransform: "capitalize",
                      mr: 1,
                      fontSize: "15px",
                    }}
                    color="info"
                    onClick={addReviewHandler}
                  >
                    Add New
                  </MDButton>
                </MDTypography>
              </MDBox> */}
            </MDBox>

            <MDBox
              sx={{
                width: "100%",
                "@media(max-width:900px)": { overflowX: "auto" },
              }}
            >
              <Table
                sx={{
                  overflowX: "scroll",
                  "@media(max-width:900px)": { maxWidth: "750px" },
                }}
                aria-label="simple table"
              >
                <TableHead
                  sx={{
                    borderBottom: "1px solid #F4F4F4",
                    width: "100%",
                    display: "table-header-group",
                  }}
                >
                  <TableRow>
                    <TableCell
                      sx={{
                        fontSize: "16px",
                        fontWeight: "700",
                        lineHeight: "19px",
                        color: "#707EAE",
                        textAlign: "left",
                        width: "5%",
                        fontFamily: "Urbanist",
                        pt: 2,
                        px: 2,
                        pb: 2,
                      }}
                    >
                      S.No.
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "16px",
                        fontWeight: "700",
                        lineHeight: "19px",
                        color: "#707EAE",
                        textAlign: "left",
                        width: "10%",
                        fontFamily: "Urbanist",
                        pt: 2,
                        px: 2,
                        pb: 2,
                      }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "16px",
                        fontWeight: "700",
                        lineHeight: "19px",
                        color: "#707EAE",
                        textAlign: "left",
                        width: "15%",
                        fontFamily: "Urbanist",
                        pt: 2,
                        px: 2,
                        pb: 2,
                      }}
                    >
                      Visit Date
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "16px",
                        fontWeight: "700",
                        lineHeight: "19px",
                        color: "#707EAE",
                        textAlign: "left",
                        width: "5%",
                        fontFamily: "Urbanist",
                        pt: 2,
                        px: 2,
                        pb: 2,
                      }}
                    >
                      Note
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "16px",
                        fontWeight: "700",
                        lineHeight: "19px",
                        color: "#707EAE",
                        textAlign: "left",
                        width: "15%",
                        fontFamily: "Urbanist",
                        pt: 2,
                        px: 2,
                        pb: 2,
                      }}
                    >
                      No. of requests
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "16px",
                        fontWeight: "700",
                        lineHeight: "19px",
                        color: "#707EAE",
                        textAlign: "left",
                        width: "5%",
                        fontFamily: "Urbanist",
                        pt: 2,
                        px: 2,
                        pb: 2,
                      }}
                    >
                      Status
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "16px",
                        fontWeight: "700",
                        lineHeight: "19px",
                        color: "#707EAE",
                        width: "15%",
                        fontFamily: "Urbanist",
                        pt: 2,
                        px: 2,
                        pb: 2,
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {requestReviewListData?.list?.length > 0 ? (
                    requestReviewListData?.list?.map((ele, index) => {
                      const serialNumber = index + 1;
                      return (
                        <TableRow key={index}>
                          <TableCell
                            align="left"
                            sx={{
                              px: 2,
                              textTransform: "capitalize",
                              fontFamily: "Urbanist",
                              fontSize: "14px",
                              fontWeight: 600,
                              lineHeight: "16.8px",
                              width: "3%",
                              textAlign: "left",
                            }}
                          >
                            {loading ? (
                              <Skeleton
                                variant="rectangular"
                                style={{
                                  marginTop: "5px",
                                  borderRadius: "5px",
                                }}
                                width={40}
                                height={37}
                              />
                            ) : (
                              serialNumber
                            )}
                          </TableCell>
                          <TableCell
                            sx={{
                              px: 2,
                              fontFamily: "Urbanist",
                              fontSize: "14px",
                              fontWeight: 600,
                              lineHeight: "16.8px",
                              width: "20%",
                              textAlign: "left",
                            }}
                            align="left"
                          >
                            {loading ? (
                              <Skeleton
                                variant="rectangular"
                                style={{
                                  marginTop: "5px",
                                  borderRadius: "5px",
                                }}
                                width={400}
                                height={37}
                              />
                            ) : typeof ele?.first_name === "string" &&
                              ele.first_name.includes("sample") ? (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <span>{ele?.first_name} </span>
                                <Tooltip
                                  title="Example business for demonstration purposes. Feel free to explore!"
                                  placement="bottom"
                                >
                                  <InfoOutlinedIcon
                                    sx={{
                                      fontSize: "18px",
                                      color: "#1976d2",
                                      cursor: "pointer",
                                    }}
                                  />
                                </Tooltip>
                              </div>
                            ) : (
                              <>{ele?.cName}</>
                            )}
                          </TableCell>
                          <TableCell
                            sx={{
                              px: 2,
                              fontFamily: "Urbanist",
                              fontSize: "14px",
                              fontWeight: 600,
                              lineHeight: "16.8px",
                              width: "10%",
                              textAlign: "left",
                            }}
                            align="left"
                          >
                            {loading ? (
                              <Skeleton
                                variant="rectangular"
                                style={{
                                  marginTop: "5px",
                                  borderRadius: "5px",
                                }}
                                width={500}
                                height={37}
                              />
                            ) : (
                              ele?.visitDate
                            )}
                          </TableCell>
                          <TableCell
                            sx={{
                              px: 2,
                              fontFamily: "Urbanist",
                              fontSize: "14px",
                              fontWeight: 600,
                              lineHeight: "16.8px",
                              width: "10%",
                              textAlign: "left",
                            }}
                            align="left"
                          >
                            {loading ? (
                              <Skeleton
                                variant="rectangular"
                                style={{
                                  marginTop: "5px",
                                  borderRadius: "5px",
                                }}
                                width={500}
                                height={37}
                              />
                            ) : (
                              ele?.note
                            )}
                          </TableCell>
                          <TableCell
                            sx={{
                              px: 2,
                              fontFamily: "Urbanist",
                              fontSize: "14px",
                              fontWeight: 600,
                              lineHeight: "16.8px",
                              width: "10%",
                              textAlign: "left",
                            }}
                            align="left"
                          >
                            {loading ? (
                              <Skeleton
                                variant="rectangular"
                                style={{
                                  marginTop: "5px",
                                  borderRadius: "5px",
                                }}
                                width={600}
                                height={37}
                              />
                            ) : (
                              ele?.noOfRequest
                            )}
                          </TableCell>
                          <TableCell
                            sx={{
                              px: 2,
                              fontFamily: "Urbanist",
                              fontSize: "14px",
                              fontWeight: 600,
                              lineHeight: "16.8px",
                              width: "10%",
                              textAlign: "left",
                            }}
                            align="left"
                          >
                            {loading ? (
                              <Skeleton
                                variant="rectangular"
                                style={{
                                  marginTop: "5px",
                                  borderRadius: "5px",
                                }}
                                width={600}
                                height={37}
                              />
                            ) : (
                              ele?.status ==="done"?"Completed":ele?.status.charAt(0).toUpperCase() + ele?.status.slice(1)
                            )}
                          </TableCell>
                          <TableCell
                            sx={{
                              pl: 2,
                              pr: 2,
                              fontSize: "14px",
                              fontWeight: 600,
                              lineHeight: "16.8px",
                              width: "15%",
                              textAlign: "left",
                            }}
                            align="right"
                          >
                            {loading ? (
                              <Skeleton
                                variant="rectangular"
                                style={{
                                  marginTop: "5px",
                                  borderRadius: "5px",
                                }}
                                width={150}
                                height={37}
                              />
                            ) : (
                              <MDBox
                                sx={{
                                  display: "flex",
                                  alignItems: "start",
                                  justifyContent: "start",
                                  gap: "10px",
                                }}
                              >
                                {ele.status === "added" && (
                                  <Tooltip title="Show QR code" placement="top">
                                    <a
                                      style={{
                                        cursor: "pointer",
                                      }}
                                      // onClick={() => handleView(ele.id)}
                                    >
                                      <img src={showIcon} alt="profile_image" />
                                    </a>
                                  </Tooltip>
                                )}

                                {ele.status === "pending" && (
                                  <Tooltip
                                    title="Send Review Request"
                                    placement="top"
                                  >
                                    <a
                                      style={{
                                        cursor: "pointer",
                                      }}
                                      onClick={() => handleSendRequest(ele)}
                                    >
                                      <img src={sendIcon} alt="profile_image" />
                                    </a>
                                  </Tooltip>
                                )}
                                {ele.status === "inprogress" && (
                                  <Tooltip title="Follow up" placement="top">
                                    <a
                                      style={{
                                        cursor: "pointer",
                                      }}
                                      onClick={() => handleSendRequest(ele)}
                                    >
                                      <img src={sendIcon} alt="profile_image" />
                                    </a>
                                  </Tooltip>
                                )}
                                <Tooltip title="Edit" placement="top">
                                  <a
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      handleEditRequest(ele.id);
                                    }}
                                  >
                                    <img
                                      src={avatarEditIcon}
                                      alt="profile_image"
                                    />
                                  </a>
                                </Tooltip>
                                <Tooltip title="Delete" placement="top">
                                  <a
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setDeletedId(ele?.id);
                                      setPermissionModal(true);
                                    }}
                                  >
                                    <img src={deleteIcon} alt="profile_image" />
                                  </a>
                                </Tooltip>
                              </MDBox>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <>
                      <tr>
                        <td colSpan="6">
                          <div
                            style={{
                              textAlign: "center",
                              fontSize: "16px",
                              fontWeight: "500",
                              lineHeight: "10px",
                              color: "#707EAE",
                              padding: "10px",
                            }}
                          >
                            No data found
                          </div>
                        </td>
                      </tr>
                    </>
                  )}
                  <TableRow style={{ height: 53 }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                </TableBody>
              </Table>
              {requestReviewListData?.list?.length > 0 ? (
                <TablePagination
                  sx={{
                    fontFamily: "urbanist",
                    fontWeight: "700",
                    "& .css-p33a0u-MuiTablePagination-selectLabel": {
                      fontFamily: "urbanist",
                      fontWeight: "500",
                    },
                    "& .css-r9d6bn-MuiSelect-select-MuiInputBase-input": {
                      fontFamily: "urbanist",
                      fontWeight: "600",
                    },
                    "& .css-188flkz-MuiTablePagination-displayedRows": {
                      fontFamily: "urbanist",
                      fontWeight: "500",
                    },
                  }}
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={totalCount}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handlePageChange}
                  onRowsPerPageChange={handleRowsPerPageChange}
                />
              ) : (
                <></>
              )}
            </MDBox>
          </MDBox>
        </DashboardLayoutCustom2>
      </MDBox>

      <Modal open={viewModalOpen}>
        <Box sx={style} position="relative">
          {/* Close Icon */}
          <IconButton
            onClick={() => setViewModalOpen(false)}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <CloseIcon />
          </IconButton>
          <Typography
            variant="h6"
            py={2}
            sx={{ fontSize: "20px" }}
            gutterBottom
          >
            Scan QR code
          </Typography>
          {requestReviewListData?.business?.restaurant_name}
          <QRCodeSVG
            value={`${window.location.host}/redirect?link=${showData.link}`}
            width={250}
            height={250}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            gap={2}
            mt={2}
          >
            <Button
              variant="contained"
              sx={{ color: "#fff", fontSize: "15px" }}
              onClick={() => setViewModalOpen(false)}
            >
              Close
            </Button>
            <Button
              variant="contained"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 1,
                color: "#fff",
                fontSize: "15px",
              }}
              onClick={() => {
                navigator.clipboard.writeText(linkToCopy);
                toast.success("Link Copied successfully");
              }}
            >
              <ContentCopyIcon sx={{ fontSize: "20px" }} />
              Copy
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal open={viewSendRequest} onClose={handleClose}>
        <Box sx={style} position="relative">
          <IconButton
            onClick={() => setViewSendRequest(false)}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <CloseIcon />
          </IconButton>
          <Typography
            variant="h6"
            py={2}
            sx={{ fontSize: "20px" }}
            gutterBottom
          >
            Send Request Review
          </Typography>

          {reviewRequestByIDData.details?.[0] && (
            <Box sx={{ mt: 1, textAlign: "left", fontSize: "12px" }}>
              <Typography>
                <b>Name:</b> {reviewRequestByIDData?.details?.[0].first_name}{" "}
              </Typography>
              <Typography>
                <b>Email:</b> {reviewRequestByIDData.details?.[0].email}
              </Typography>
              <Typography>
                <b>Note:</b> {reviewRequestByIDData.details?.[0].review_note}
              </Typography>
              <Typography>
                <b>Visit Date: </b>
                {reviewRequestByIDData.details?.[0].visit_date}
              </Typography>
              <Typography>
                <b>No. of Request:</b>
                {reviewRequestByIDData.details?.[0]?.no_of_requests}
              </Typography>
            </Box>
          )}

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            gap={2}
            mt={2}
          >
            <Button
              variant="contained"
              sx={{ color: "#fff", fontSize: "15px" }}
              onClick={() => handleSNewendRequest(selectedRequest.id)}
            >
              Confirm
            </Button>
            <Button
              variant="contained"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 1,
                color: "#fff",
                fontSize: "15px",
              }}
              onClick={() => setViewSendRequest(false)}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={permissionModal}
        onClose={() => {
          setPermissionModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDBox sx={style}>
          <MDBox sx={{ position: "relative", pt: "15px" }}>
            <MDBox
              sx={{
                position: "absolute",
                top: "-15px",
                left: "38%",
              }}
            ></MDBox>
            <MDBox>
              <h2
                id="modal-modal-title"
                style={{
                  fontFamily: "urbanist",
                  fontSize: "24px",
                  fontWeight: 700,
                  color: "#333",
                  textAlign: "center",
                }}
              >
                Confirm Deletion
              </h2>
              <p
                id="modal-modal-description"
                style={{
                  fontFamily: "urbanist",
                  fontSize: "18px",
                  fontWeight: 400,
                  lineHeight: "30px",
                  marginTop: "14px",
                  color: "#818181",
                  textAlign: "center",
                }}
              >
                Are you sure you want to delete this request.
              </p>
            </MDBox>
            <MDButton
              variant="gradient"
              color="info"
              sx={{
                paddingLeft: "4rem",
                paddingRight: "4rem",
                paddingTop: "1rem",
                paddingBottom: "1rem",
                borderRadius: "45px",
                marginTop: "30px",
              }}
              onClick={() => {
                setPermissionModal(false);
              }}
            >
              Cancel
            </MDButton>
            <MDButton
              variant="gradient"
              color="error"
              sx={{
                paddingLeft: "4rem",
                paddingRight: "4rem",
                paddingTop: "1rem",
                paddingBottom: "1rem",
                borderRadius: "45px",
                marginTop: "30px",
                marginLeft: { xs: "7px", sm: "16px" },
              }}
              onClick={() => handleRemove()}
            >
              Delete
            </MDButton>
          </MDBox>
        </MDBox>
      </Modal>
      <Modal
        open={editModal}
        onClose={() => setEditModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDBox sx={style}>
          <MDBox sx={{ px: 2, py: 2 }}>
            <h2
              id="modal-modal-title"
              style={{
                fontFamily: "urbanist",
                fontSize: "24px",
                fontWeight: 700,
                color: "#333",
                textAlign: "center",
              }}
            >
              Edit Review Request
            </h2>
            <Grid container spacing={3}>
              {[
                // {
                //   label: " Name",
                //   key: "name",
                //   required: true,
                //   value: showRequestData?.review_request?.name,
                // },
                // {
                //   label: "Last Name",
                //   key: "last_name",
                //   value: editRequestData?.review_request?.last_name,
                // },
                // {
                //   label: "Email",
                //   key: "email_address",
                //   type: "email",
                //   value: showRequestData?.review_request?.email,
                // },
                // {
                //   label: "Phone Number",
                //   key: "phone_number",
                //   value: editRequestData?.review_request?.phone_number,
                // },
                {
                  label: "Visit Date",
                  key: "visit_date",
                  required: true,
                  value: showRequestData?.review_request?.visitDate,
                },
                {
                  label: "Note",
                  key: "note",
                  value: showRequestData?.review_request?.note,
                },
              ].map((field) => (
                <Grid item xs={12} md={6} key={field.key}>
                  <MDTypography
                    variant="subtitle2"
                    sx={{ color: "#212121", textAlign: "left" }}
                    mt={1}
                    mb={0.5}
                  >
                    {field.label}
                    {field.required && (
                      <MDBox sx={{ color: "red" }} component="span">
                        *
                      </MDBox>
                    )}
                  </MDTypography>

                  {field.key === "visit_date" ? (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        sx={{ width: "100%" }}
                        defaultValue={
                          showRequestData?.review_request?.visitDate
                            ? dayjs(showRequestData?.review_request?.visitDate)
                            : null
                        }
                        disabled
                        onChange={handleDateChange}
                        renderInput={(params) => (
                          <TextField fullWidth {...params} />
                        )}
                      />
                    </LocalizationProvider>
                  ) : (
                    <MDInput
                      type={field.type || "text"}
                      placeholder={field.label}
                      defaultValue={field.value}
                      onChange={(e) => handleChange(field.key, e.target.value)}
                      fullWidth
                      disabled={field.key === "name"}
                      sx={{
                        "& .MuiInputBase-root": {
                          borderRadius: "45px",
                          paddingRight: "41px",
                        },
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "45px",
                        },
                      }}
                    />
                  )}
                </Grid>
              ))}
            </Grid>

            {/* Buttons */}
            <MDBox
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                mt: 6,
              }}
            >
              <MDButton
                variant="gradient"
                color="info"
                sx={{
                  px: 6,
                  py: 2,
                  borderRadius: "45px",
                }}
                onClick={() => setEditModal(false)}
              >
                Cancel
              </MDButton>

              <MDButton
                variant="gradient"
                color="info"
                sx={{
                  px: 6,
                  py: 2,
                  borderRadius: "45px",
                }}
                onClick={() => updateReviewRequest()}
              >
                Submit
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Modal>
    </>
  );
}

export default ReviewsList;
